import React from 'react';
import { Form, Row, Col } from 'react-bootstrap';

var TabFaixasContas = function (_ref) {
  var parametros = _ref.parametros;
  var onChange = _ref.onChange;

  var p = parametros || {};

  var handleChange = function (campo, valor) {
    onChange(Object.assign({}, p, { [campo]: valor }));
  };

  var faixa = function (label, campoIni, campoFim) {
    return (
      <Row key={label} className="align-items-center mb-2">
        <Col md={3}>
          <Form.Label className="mb-0">{label}</Form.Label>
        </Col>
        <Col md={1} className="text-center pr-0">
          <small className="text-muted">De</small>
        </Col>
        <Col md={2}>
          <Form.Control
            type="number"
            size="sm"
            value={p[campoIni] || ''}
            onChange={function (e) { handleChange(campoIni, e.target.value); }}
          />
        </Col>
        <Col md={1} className="text-center pr-0">
          <small className="text-muted">A</small>
        </Col>
        <Col md={2}>
          <Form.Control
            type="number"
            size="sm"
            value={p[campoFim] || ''}
            onChange={function (e) { handleChange(campoFim, e.target.value); }}
          />
        </Col>
      </Row>
    );
  };

  return (
    <div>
      <Row className="mb-3">
        <Col md={3}>
          <Form.Group>
            <Form.Label>Conta Capital de 0 a</Form.Label>
            <Form.Control
              type="number"
              value={p.conta_inicial || ''}
              onChange={function (e) { handleChange('conta_inicial', e.target.value); }}
            />
          </Form.Group>
        </Col>
      </Row>
      <hr />
      <h6 className="mb-3">Faixas de Contas</h6>
      {faixa('Fornecedor', 'for_ini', 'for_fim')}
      {faixa('Despesas', 'desp_ini', 'desp_fim')}
      {faixa('Sócios', 'socio_ini', 'socio_fim')}
      {faixa('Caixa', 'caixa_ini', 'caixa_fim')}
      {faixa('Banco', 'banco_ini', 'banco_fim')}
      {faixa('Cobrador', 'cobra_ini', 'cobra_fim')}
      {faixa('Contas Internas Out.', 'interna_ini', 'interna_fim')}
      {faixa('Projeto', 'projeto_ini', 'projeto_fim')}
      {faixa('Corretor', 'corretor_ini', 'corretor_fim')}
    </div>
  );
};

export default TabFaixasContas;
